import { render, staticRenderFns } from "./BatchUpdateSceneDir.vue?vue&type=template&id=77c5a076"
import script from "./BatchUpdateSceneDir.vue?vue&type=script&lang=js"
export * from "./BatchUpdateSceneDir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports